<template>
  <div class="col-12 col-sm-5 col-md-4 col-lg-4">
    <div class="card">
      <div class="checkbox-container">
        <b-form-group>
          <b-form-checkbox v-model="localSelected" :disabled="disabled"/>
        </b-form-group>
      </div>
      <div class="card-section">
        <div class="icon-container">
          <slot name="icon">
            <img v-if="iconImg.src" :src="iconImg.src" :alt="iconImg.alt" :height="iconImg.height"
              :width="iconImg.width" />
          </slot>
        </div>
        <div class="item-section">
          <div class="item-label-title">{{ title }}</div>
          <div class="item-label-caption" v-if="subtitle">{{ subtitle }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OptionDeliveryCard',
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      default: ''
    },
    cardHeight: {
      type: String,
      default: '180px'
    },
    cardWidth: {
      type: String,
      default: '180px'
    },
    iconImg: {
      type: Object,
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localSelected: this.value
    }
  },
  watch: {
    value(newVal) {
      this.localSelected = newVal
    },
    localSelected(newVal) {
      this.$emit('input', newVal)
    }
  }
}
</script>

<style scoped>
.card {
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: #F5F9FA;
  border: 1px solid #DDE0E4;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 24px 16px;
  min-height: 200px;
  max-width: 240px;
}

.card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.checkbox-container {
  position: absolute;
  top: 16px;
  right: 16px;
}

.card-section {
  text-align: center;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.icon-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.icon-container img {
  max-width: 48px;
  height: auto;
}

.item-label-title {
  font-weight: 600;
  margin-bottom: 4px;
  color: #5E5873;
}

.item-label-caption {
  font-weight: 300;
  color: #6E6B7B;
  font-size: 10px;
}
</style>